import { FaCheckCircle } from 'react-icons/fa';
import { IoWarning } from 'react-icons/io5';

import { FraudRiskLevel } from '~/core/shared/constants';
import { Nullable } from '~/core/shared/types';

export const getRiskDisplayConfig = (
  fraudRiskLevel?: Nullable<FraudRiskLevel>,
) => {
  switch (fraudRiskLevel) {
    case FraudRiskLevel.Low:
      return {
        color: 'black.600',
        bgColor: 'green.100',
        dividerColor: 'green.200',
        iconColor: 'green.600',
        icon: FaCheckCircle,
      };
    case FraudRiskLevel.Medium:
      return {
        color: 'black.600',
        bgColor: 'yellow.100',
        dividerColor: 'yellow.300',
        iconColor: 'yellow.600',
        icon: IoWarning,
      };
    case FraudRiskLevel.High:
      return {
        color: 'white',
        bgColor: 'red.500',
        dividerColor: 'red.200',
        iconColor: 'white',
        icon: IoWarning,
      };
    default:
      return {
        color: 'gray.600',
        bgColor: 'gray.50',
        dividerColor: 'gray.200',
        iconColor: 'gray.600',
        icon: undefined,
      };
  }
};
